export const getDeviceId = () => {
    // eslint-disable-next-line
    const urlParams = new URLSearchParams(location.search)

    // the url should pass the deviceId, ie: `localhost:8090?deviceId=abc123
    if (urlParams.get('deviceId')) return urlParams.get('deviceId')

    return Math.random().toString(18).substr(2).substr(0, 6)
}
